import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import ProductSectionForm from 'ui-shared/Forms/ProductSectionForm'

const MusicSectionCreate: React.FC = () => {
  return (
    <SectionWrapper title={'resources.musicsections.createSection'}>
      <Create>
        <ProductSectionForm entity="musics" />
      </Create>
    </SectionWrapper>
  )
}

export default MusicSectionCreate
